import React, { useEffect, useState } from 'react';
import { translate } from '../../services/translate';
import { dashboardSummaryService } from '../../services/central-api/dashboard-summary';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { StyleProp, TextStyle } from 'react-native';

interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    zIndex: number;
    required?: boolean;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    label?: string;
    setFirstValue?: boolean;
}

export default function PlateGroupDropdown({ value, setValue, zIndex, required, labelStyle, viewStyle, label, setFirstValue }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);

    async function getPlateGroups() {
        try {
            const plateGroups = await dashboardSummaryService.getPlateGroupsSimplified();

            setItems(plateGroups.map((plateGroup) => {
                return {
                    value: plateGroup.id,
                    label: plateGroup.name
                };
            }));

            if (value === 0 && setFirstValue && plateGroups.length > 0) {
                setValue(plateGroups[0].id);
            }
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getPlateGroups();
    }, []);

    return (
        <FilterDropdown
            label={label ?? translate('plateGroup')}
            placeholder={translate('groupName')}
            items={items}
            required={required}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}
